import React from "react";

import Slider from "rc-slider";

import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import styles from "./SliderPrice.module.sass";

const sliderWrapper = (props) => {
  return (
    <div className={styles.sliderContent}>
      <h3 className={styles.titleSlider}>
        Alterar o valor{" "}
        {props.simulationType === "parcela" ? "da parcela" : "do crédito"}
      </h3>
      {props.customInput}

      <div className={styles.sliderContainer}>
        <button
          className={styles.btnSlider}
          onClick={() =>
            props.onChange(Math.max(props.value - props.step, props.min))
          }
        >
          -
        </button>

        <Slider
          onChange={(value) => {
            if (document.activeElement.tagName !== "INPUT") {
              props.onChange(Math.min(value, props.max));
            }
          }}
          value={props.value}
          step={props.step}
          min={props.min}
          max={props.max + (props.max - props.min)%props.step}
          handleStyle={{
            borderColor: "#005fc8",
            backgroundColor: "#005fc8",
            height: 20,
            width: 20,
            marginTop: -5,
          }}
          trackStyle={{ backgroundColor: "#005fc8", height: 8 }}
          railStyle={{ backgroundColor: "#e8e8e8", height: 8 }}
        />

        <button
          className={styles.btnSlider}
          onClick={() =>
            props.onChange(Math.min(props.value + props.step, props.max))
          }
        >
          +
        </button>
      </div>
    </div>
  );
};

export default sliderWrapper;
